export default "__VITE_ASSET__jKavpKh2__"